import { Link, useParams } from 'react-router-dom'
import { LivePlayer, OnAirBadge } from '../../components/LivePlayer'
import { PublicLayout } from '../../components/PublicLayout'
import { Badge, EmptyState, LoadingBlock } from '../../components/ui'
import { usePublicLive } from '../../hooks/usePublic'
import { timeAgo } from '../../utils/format'

/** A show's live page: the broadcast while it is on air, and a note when it is not. */
export function PublicLivePage() {
  const { workspaceSlug = '', showSlug = '' } = useParams()
  const live = usePublicLive(workspaceSlug, showSlug)
  if (live.isPending) {
    return (
      <PublicLayout>
        <LoadingBlock />
      </PublicLayout>
    )
  }
  if (live.isError) {
    return (
      <PublicLayout title="Not found">
        <EmptyState title="There is nothing here" body="This show does not go live, or the address is wrong." />
      </PublicLayout>
    )
  }
  const data = live.data
  const heading = data.on_air && data.title ? data.title : data.show_title
  return (
    <PublicLayout title={data.on_air ? `${heading} · Live` : data.show_title}>
      <header className={`public-show${data.artwork_url ? ' has-art' : ''}`}>
        {data.artwork_url && <img className="artwork" src={data.artwork_url} alt="" />}
        <div className="stack-sm">
          <div>{data.on_air ? <OnAirBadge /> : <Badge>Off air</Badge>}</div>
          <h1>{heading}</h1>
          {heading !== data.show_title && <p className="muted">{data.show_title}</p>}
          {data.author && <p className="muted">{data.author}</p>}
          {data.on_air && data.started_at && <p className="muted small">Started {timeAgo(data.started_at)}</p>}
        </div>
      </header>
      {data.on_air && data.hls_url ? (
        <LivePlayer src={data.hls_url} poster={data.artwork_url} />
      ) : data.on_air && data.restricted ? (
        <EmptyState
          title="Live now, on its own site"
          body={`${data.show_title} streams for its members on its own website. Watch it there.`}
        />
      ) : (
        <EmptyState
          title="Not live right now"
          body="This page plays the show whenever it goes live. It checks every few seconds, so you can leave it open."
          action={data.has_episodes ? <Link to={`/p/${workspaceSlug}/${showSlug}`}>Listen to past episodes</Link> : undefined}
        />
      )}
    </PublicLayout>
  )
}
